export const settings = {
  selector: '.js-quizBuilder',
  $quiz() {
    return document.querySelector(this.selector);
  },
};
